const TOKEN_URL = "https://api.ebels.app/";

export default TOKEN_URL;
